// needUse из tc_type_docs: 1 — обязателен (без него заявку не отправить),
// null — обязателен по ситуации (отправка после подтверждения), прочее — необязателен.
export const isDocMandatory = (doc) => doc?.needUse != null && +doc.needUse === 1

export const isDocConditional = (doc) => doc?.needUse == null

/**
 * Вложение относится к слоту формы:
 * — по id_type_doc, если есть (новые записи);
 * — иначе по file_type ↔ idFileType (старые вложения / tipdoc).
 * @param {object} att
 * @param {object} doc слот из dogDocList (id = idTypeDoc)
 */
export const isAttachForDoc = (att, doc) => {
    if (!att || !doc) return false
    const slot = att.id_type_doc ?? att.idTypeDoc
    if (slot != null && slot !== '') return String(slot) === String(doc.id)
    const tipdoc = att.file_type ?? att.fileType
    if (tipdoc == null || tipdoc === '') return false
    return String(tipdoc) === String(doc.idFileType ?? doc.id)
}

/**
 * Документы, по типу которых нет ни загруженного, ни подготовленного к загрузке файла.
 * @param {object[]} docs
 * @param {(object|string|number)[]} attached вложения и/или type_id из newdogFiles
 */
export const notAttachedDocs = (docs, attached) => {
    return docs.filter((doc) => {
        const has = attached.some((a) => {
            if (a != null && typeof a === 'object') return isAttachForDoc(a, doc)
            return String(a) === String(doc.id)
                || (doc.idFileType != null && String(a) === String(doc.idFileType))
        })
        return !has
    })
}
